export const auth = {
  login: {
    heading: "ログイン",
    emailOrPhoneLabel: "メールアドレスまたは電話番号",
    emailOrPhonePlaceholder: "メールアドレスまたは電話番号（ハイフンなし）",
    passwordLabel: "パスワード",
    passwordToggleAlt: "パスワード表示切替",
    loginButton: "ログイン",
    loggingIn: "ログイン中...",
    loginFailed: "ログインに失敗しました",
    invalidCredentials:
      "電話番号またはメールアドレスまたはパスワードが正しくありません",
    freePointsPromo: "今なら無料ポイントプレゼント！",
    signupFree: "新規登録【無料】",
    forgotPasswordPrefix: "パスワードをお忘れの方は",
    contactPrefix: "お問い合わせの方は",
    here: "こちら",
    validation: {
      emailOrPhoneRequired: "メールアドレスまたは電話番号を入力してください",
      emailOrPhoneInvalid:
        "メールアドレスまたは10-11桁の電話番号（ハイフンなし）を入力してください",
      passwordRequired: "パスワードを入力してください",
    },
  },
  nativeLogin: {
    loggingIn: "ログイン中...",
  },
  register: {
    title: "新規登録",
    name: "ニックネーム",
    email: "メールアドレス",
    password: "パスワード",
    passwordConfirm: "パスワード確認",
    age: "年齢",
    region: "地域",
    regionOverseas: "海外",
    submit: "登録",
    cancel: "キャンセル",
    hasAccount: "すでにアカウントをお持ちの方",
    login: "ログイン",
  },
  nativeRegister: {
    landingTitle: "はじめましょう",
    landingDescription:
      "ニックネームと年齢を入力するだけですぐに始められます。",
    landingTaglinePre: "あなたに",
    landingTaglineMid: "ぴったりな",
    landingTaglineHighlight: "出会い",
    landingTaglinePost: "を",
    landingTaglineSub: "今すぐはじめよう",
    badgeAnonymous: "匿名OK",
    badgeNoIdentity: "本人確認なし",
    badgeFree: "無料登録",
    ageRestriction: "18歳未満の方はご利用いただけません",
    nativeTaglinePre: "ステキな",
    nativeTaglineHighlight: "出会い",
    nativeTaglinePost: "を見つけよう",
    nativeSubtitle: "30秒で登録完了",
    onlineCount: (args: { count: string | number }) =>
      `現在 ${args.count} 人がオンライン`,
    quickStart: "30秒ではじめられます",
    nicknameLabel: "ニックネーム",
    nicknamePlaceholder: "ニックネーム",
    ageLabel: "年齢",
    ageSuffix: "歳",
    regionLabel: "地域",
    randomButton: "ランダム",
    termsLink: "利用規約",
    and: "と",
    privacyLink: "プライバシーポリシー",
    agreeCheckbox: "に同意します",
    bonusNow: "今だけ",
    bonusPoints: "250pt",
    bonusTitle: "プレゼント中！",
    bonusDescription: "新規登録するともらえる",
    freeStart: "無料ではじめる",
    start: "新規登録",
    hasAccount: "すでに会員の方はこちら",
    loggingIn: "ログイン中...",
    registering: "登録中...",
    randomNickname: "ランダム生成",
    agreeTerms: "利用規約とプライバシーポリシーに同意します",
    submitting: "登録中...",
    submit: "無料で始める",
    alreadyRegistered: "すでに登録されています。ログイン画面へ移動します。",
    failed: "登録に失敗しました",
  },
  recovery: {
    title: "アカウント復帰",
    message: "退会済みのアカウントです。復帰しますか？",
    confirm: "復帰する",
  },
  contact: {
    linkText: "お問い合わせはこちら",
    modalTitle: "サポートへのお問い合わせ",
    modalDescription:
      "ログインに問題がある場合は、サポートチームにメールでお問い合わせください。端末情報が自動で入力されます。",
    emailButton: "メールで問い合わせる",
    mailSubject: "[Koru] お問い合わせ",
    unknown: "不明",
  },
} as const;
